var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['ticket-status', _vm.cssClass, 'd-flex justify-content-center align-items-center', {'large': _vm.size === 'lg'}, {'text-large': _vm.summary && _vm.isInStandaloneMode}]},[_vm._v(" "+_vm._s(_vm.ticketStatus)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }